<div id="{{id}}" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="Error" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-danger">
                <h4 class="modal-title" style="color: white;" id="danger-header-modalLabel">Error</h4>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-hidden="true"></button>
            </div>
            <div class="modal-body">
                <h3>{{message}}</h3>
            </div>
            <div class="modal-footer" style="justify-content: center;">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">Continue</button>
            </div>
        </div>
    </div>
</div>